import TableDetailsPanel from "@/components/TableDetailsPanel";
import { Row } from "@tanstack/react-table";
import { OrderRow } from "@/pages/billing/types";
import { centsToDollarsFormatted } from "@/lib/currencyHelpers";

export const ProductTable = ({ row }: { row: Row<OrderRow> }) => {
  const products = row.original.lineItems || [];
  return (
    <TableDetailsPanel
      data={products}
      title={`Products (${products.length})`}
      columns={[
        {
          accessorKey: "name",
          header: "Product Name",
          enableSorting: false,
          size: 400,
          meta: { headerClassName: "hide-header-in-column" }
        },
        {
          accessorKey: "priceCents",
          header: "Price",
          enableSorting: false,
          meta: { className: "text-right", headerClassName: "justify-end" },
          cell: ({ getValue }) => {
            const value = getValue() as number | undefined;
            return value !== undefined && value !== null ? (
              centsToDollarsFormatted(value)
            ) : (
              <span className="opacity-20">--</span>
            );
          }
        },
        {
          accessorKey: "quantity",
          header: "Quantity",
          enableSorting: false,
          meta: { className: "text-right", headerClassName: "justify-end" }
        },
        {
          accessorKey: "totalPrice",
          header: "Amount",
          enableSorting: false,
          meta: { className: "text-right", headerClassName: "justify-end" },
          cell: ({ getValue }) => {
            const value = getValue() as number | undefined;
            return value !== undefined && value !== null ? (
              centsToDollarsFormatted(value)
            ) : (
              <span className="opacity-20">--</span>
            );
          }
        }
      ]}
    />
  );
};
